// Die verbindliche Farbpalette laut Stilrichtlinie (docs/style-guide.md).
// Painter verwenden ausschließlich diese Farben bzw. daraus abgeleitete Töne (mix/shade).
export const P = {
  ink: '#1d1a17',
  night0: '#0c1422',
  night1: '#16243a',
  night2: '#24395a',
  night3: '#3a5578',
  sea0: '#1f3f45',
  sea1: '#2f5d62',
  sea2: '#4a8582',
  wood0: '#2a1810',
  wood1: '#3f2516',
  wood2: '#5c3720',
  wood3: '#7c4c2b',
  wood4: '#a06d40',
  plaster0: '#6e5338',
  plaster1: '#9a7a54',
  plaster2: '#c4a374',
  paper: '#efe2c4',
  amber0: '#b8741f',
  amber1: '#e0a346',
  amber2: '#f6c86d',
  amber3: '#ffe6ad',
  red0: '#5e1f1a',
  red1: '#8e2f25',
  red2: '#bf5240',
  green0: '#26301f',
  green1: '#3f5233',
  green2: '#6b8050',
  brass0: '#6f5420',
  brass1: '#b08a3e',
  brass2: '#e2c27a',
  iron0: '#24272b',
  iron1: '#3d4248',
  iron2: '#6c737a',
  white: '#f7f1e3',
  skin0: '#8a5a3c',
  skin1: '#c48a62',
  skin2: '#e3b48c',
} as const;

export type PaletteKey = keyof typeof P;
